import styled from 'styled-components';
import colors from '@theme/colors';

const Page = styled.div`
  @media screen {
    background-color: ${colors.FORUM_GREY};
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-bottom: 100px;

    @media (max-width: 500px) {
      background-color: ${colors.WHITE};
      padding-bottom: 70px;
    }
  }
`;
const DocumentWrapper = styled.div`
  @media screen {
    background-color: ${colors.WHITE};
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 30px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.16), 0 3px 10px rgba(0, 0, 0, 0.23);
    border-radius: 2px;

    @media (max-width: 500px) {
      box-shadow: inherit;
      padding-left: 15px;
      padding-right: 15px;
      padding-top: 15px;
    }
  }
`;

const Container = styled.div`
  @media screen {
    max-width: 740px;
  }

  @media print {
    margin: 0;
    width: 100%;
  }
`;

export default {
  Page,
  Container,
  DocumentWrapper,
};



// WEBPACK FOOTER //
// ./components/layout/TranscriptPage.js